<template>
  <div>
    <h1 class="text-xl font-medium leading-6 text-gray-900 mr-2">Great! Let's start setting up your company.</h1>
    <p class="mt-1 text-sm text-gray-500">
      We'll use this for displaying your company's information throughout the app, job postings, and more.
    </p>

    <div v-if="loaded" class="mt-6 mb-6 grid grid-cols-1 gap-x-4 gap-y-8 max-w-sm mx-auto">
      <TextInput
        label="Company Name"
        placeholder="John"
        :modelValue="team.company"
        @update:modelValue="
          value => {
            team.company = value;
          }
        "
      />
      <FileInput
        label="Company Logo"
        limits="any Image"
        :imageholder="team.companyLogo"
        :modelValue="team.companyLogoFile"
        accept="image/*"
        @update:modelValue="team.companyLogoFile = $event"
      />
    </div>

    <div class="py-3 flex justify-center">
      <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
        <TButton
          @click="nextStep"
          color="amber"
          label="Next Step"
          :disabled="!team.company || (!team.companyLogoFile && !team.companyLogo)"
        />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      team: {
        id: '',
        company: '',
        companyLogo: '',
        companyLogoFile: null,
      },
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      fetch(`/api/teams/1`)
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.team.id = data.record.id;
          self.team.company = data.record.company;
          self.team.companyLogo = data.record.logo;
          self.loaded = true;
        });
    },
    goBack() {
      this.$emit('go-back');
    },
    nextStep() {
      const self = this;
      let formData = new FormData();
      formData.append('company', self.team.company);
      self.team.companyLogoFile ? formData.append('company_logo', self.team.companyLogoFile) : null;
      fetch(`/api/teams/${self.team.id}`, {
        method: 'PUT',
        body: formData,
        headers: {
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.status != 'error') {
            self.$emit('go-forward');
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Profile update error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
